@if (!reload) {
    <div>
        @if (!this.modalOptions.options.context) {
            <div data-bb="contextHelpItems">
                @for (item of helpItems; track item) {
                    <ul class="ap-item-list">
                        <li
                            ap-list-item
                            [isTitleBold]="true"
                            actionType="internalLink"
                            [title]="item.title"
                            [showTopBorder]="false"
                            [showBottomBorder]="true"
                            (itemClicked)="openDetailHelpContext(item)"
                        ></li>
                    </ul>
                }
                @if (modalOptions.options.openChat) {
                    <mijn-start-chat (openChat)="onOpenChat()" />
                } @else {
                    <ap-contact-info />
                }
            </div>
        }
        @if (this.modalOptions.options.context) {
            <div>
                <h1 data-bb="detailContextHelpTitle">{{ modalOptions.options.context.title }}</h1>
                <p data-bb="detailContextHelpText" [innerHTML]="modalOptions.options.context.subTitle"></p>
                @if (!!modalOptions.options.context.linkText) {
                    <ap-button [text]="true" (click)="detailClick(modalOptions.options.context)">
                        {{ modalOptions.options.context.linkText }}
                    </ap-button>
                }
            </div>
        }
    </div>
}
